import React from "react";
import styled from "@emotion/styled";
import useWindowSize from "../../hooks/useWindowSize";

const PortfolioTitle = () => {
  const size = useWindowSize();
  const DivTitle = styled.div`
    font-family: "Orbitron", sans-serif, "Franklin Gothic Medium",
      "Arial Narrow", Arial, sans-serif;
    display: flex;
    position: relative;
    align-content: center;
    @keyframes rubberBand {
      0% {
        transform: scale3d(1, 1, 1);
      }
      25% {
        transform: scale3d(1.25, 0.75, 1);
      }
      35% {
        transform: scale3d(1.3, 1, 1.25);
      }
      65% {
        transform: scale3d(0.8, 1.3, 1.1);
      }
      100% {
        transform: scale3d(1, 1, 1);
      }
    }
  `;
  const H1title = styled.h1`
    color: rgb(88, 88, 88);
    font-size: ${size.width <= 602 ? "3em " : "5em"};
    &:hover {
      animation: rubberBand 0.8s;
      color: rgb(158, 211, 245);
    }
  `;

  return (
    <DivTitle>
      <H1title>P</H1title>
      <H1title>o</H1title>
      <H1title>r</H1title>
      <H1title>t</H1title>
      <H1title>f</H1title>
      <H1title>o</H1title>
      <H1title>l</H1title>
      <H1title>i</H1title>
      <H1title>o</H1title>
    </DivTitle>
  );
};

export default PortfolioTitle;
